import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Tabs } from "antd";
import { findMenuItem } from "../../utils/generalUtils";

import "../../styles/components/selectComponent/tabSelection.scss";

const TabSelection = ({
  menuItems,
  currentTabKey,
  setTabAction,
  defaultComponent,
}) => {
  const dispatch = useDispatch();
  const currentTab = useSelector((state) => state.generalSlice[currentTabKey]);

  // The stored tab key can go stale — e.g. a Program Chair-only approver
  // used to default to "tr-local", but that tab is no longer in menuItems
  // for them. Fall back to the first available tab instead of "Page not
  // found", and correct the stored key so the tab bar highlights it too.
  const activeItem = findMenuItem(menuItems, currentTab) || menuItems[0];

  useEffect(() => {
    if (activeItem && activeItem.key !== currentTab) {
      dispatch(setTabAction(activeItem.key));
    }
  }, [activeItem, currentTab, dispatch, setTabAction]);

  const handleTabChange = (key) => {
    dispatch(setTabAction(key));
  };

  // const [hoveredTabKey, setHoveredTabKey] = useState(null);

  const renderContent = () =>
    activeItem ? activeItem.component : defaultComponent || <p>Page not found</p>;

  return (
    <div className="tab-selection-container">
      <Tabs
        // type="card"
        tabBarGutter={0}
        size="large"
        activeKey={activeItem?.key}
        onChange={handleTabChange}
        indicator={{ size: (origin) => origin - 30, align: "center" }}
        items={menuItems.map((item) => ({
          key: item.key,
          label: (
            <div className="tabs-label">
              <span style={{ fontSize: "16px" }}>{item.icon}</span>
              <span>{item.label}</span>
            </div>
          ),
        }))}
        className="tab-selection-tabs"
      />
      <div className="tab-selection-content">{renderContent()}</div>
    </div>
  );
};

export default TabSelection;
